(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("pwaMembersController", pwaMembersController);

  pwaMembersController.$inject = [
    "_",
    "$rootScope",
    "queryParams",
    "thisSiteSettings",
    "Users",
    "UsersApi",
    "ConnectsApi",
  ];

  function pwaMembersController(
    _,
    $rootScope,
    queryParams,
    thisSiteSettings,
    Users,
    UsersApi,
    ConnectsApi,
  ) {
    var vm = this;
    let loadedMemberConnections = false;
    // properties
    vm.moment = window.moment;
    // methods
    vm.renderCustomAttr = renderCustomAttr;
    vm.canShowAttr = canShowAttr;
    getMemberConnections();
    /**
     * Render a custom attribute according to its type
     *
     * @param  {string}    key   The attribute key
     * @param  {string}    type  The attribute type
     * @return {string}
     */
    function renderCustomAttr(key, type) {
      switch (type) {
        case "checkboxes":
          var options = thisSiteSettings.user_attrs;
          var option = options.find(function (item) {
            return item.key == key;
          });
          var values = vm.member.custom_attrs[key]
            .map(function (v, i) {
              return v === 1 ? option.options.options[i].value : null;
            })
            .filter(function (v) {
              return v;
            });

          return values.join(", ");
        default:
          return vm.member.custom_attrs[key];
      }
    }
    /**
     * Retrieves this member's connections from the API
     * @return {void}
     */
    function getMemberConnections() {
      vm.isLoadingConnections = true;

      const handleMemberConnectionsResponse = (response) => {
        vm.connections = response;
        loadedMemberConnections = true;
        vm.isLoadingConnections = false;
      };

      ConnectsApi.get(
        {
          with: "userTo",
          page_size: 100,
        },
        handleMemberConnectionsResponse,
      );
    }

    /**
     * Determines whether an attribute can be displayed
     *
     * @param {string} key
     * @returns {boolean}
     */
    function canShowAttr(key) {
      var attr = _.find(thisSiteSettings.user_attrs, { key: key }) || {};
      var canShow =
        (!!attr.visible && !attr.private) ||
        (!!attr.visible && !!attr.private && !!$rootScope.thisUser);
      return canShow;
    }
  }
})(angular);
